// Business Information
export const ROC_LICENSE = "ROC 362827";
export const IS_BONDED = true;
export const IS_INSURED = true;
export const BUSINESS_NAME = "Tru American Plumbing Purifications";
export const BUSINESS_NAME_LEGAL = "Tru American Plumbing Purifications LLC";
export const BUSINESS_TAGLINE = "Veteran-Owned & Family-Operated";
export const BUSINESS_DESCRIPTION = "Tru American Plumbing Purifications is a Veteran-owned and family-operated business providing expert plumbing and water solutions to Tolleson and the West Valley. From emergency pipe repairs, slab leak detection, and water heater installs to specialized Water Softener and Reverse Osmosis systems, we handle your home's plumbing health. We offer 24/7 intelligent scheduling via our advanced voice assistant, ensuring you can book a repair or get support at any time. We are committed to honest pricing, American quality, and protecting your home from Arizona's harsh water.";
export const FOUNDING_VALUES = ["Honest Pricing", "American Quality", "Protecting Your Home"];
export const PHONE = "(480) 322-2567";
export const PHONE_LINK = "tel:+14803222567";
export const EMAIL = "truwateraz@gmail.com";

// Service Areas
export const PRIMARY_SERVICE_AREA = "Tolleson, AZ";
export const WEST_VALLEY_CITIES = [
  "Tolleson",
  "Avondale",
  "Goodyear",
  "Litchfield Park",
  "Glendale",
  "Peoria",
  "Surprise",
  "Sun City",
  "Sun City West",
  "El Mirage",
  "Buckeye",
  "Phoenix",
];

// Cities with dedicated pages
export const CITY_PAGES = [
  { slug: "tolleson-az", name: "Tolleson", state: "AZ" },
  { slug: "avondale-az", name: "Avondale", state: "AZ" },
  { slug: "goodyear-az", name: "Goodyear", state: "AZ" },
  { slug: "glendale-az", name: "Glendale", state: "AZ" },
  { slug: "peoria-az", name: "Peoria", state: "AZ" },
  { slug: "surprise-az", name: "Surprise", state: "AZ" },
  { slug: "phoenix-az", name: "Phoenix", state: "AZ" },
  { slug: "buckeye-az", name: "Buckeye", state: "AZ" },
  { slug: "litchfield-park-az", name: "Litchfield Park", state: "AZ" },
  { slug: "sun-city-az", name: "Sun City", state: "AZ" },
  { slug: "sun-city-west-az", name: "Sun City West", state: "AZ" },
  { slug: "el-mirage-az", name: "El Mirage", state: "AZ" },
];

// Plumbing Services
export const PLUMBING_SERVICES = [
  {
    slug: "emergency-plumbing",
    title: "Emergency Plumbing",
    shortDesc: "Fast response when you need it most",
    icon: "AlertCircle",
  },
  {
    slug: "slab-leak-detection",
    title: "Slab Leak Detection",
    shortDesc: "Advanced detection under foundations",
    icon: "ScanSearch",
  },
  {
    slug: "drain-cleaning",
    title: "Drain Cleaning",
    shortDesc: "Clear clogs and restore flow",
    icon: "Droplets",
  },
  {
    slug: "leak-detection-repair",
    title: "Leak Detection & Repair",
    shortDesc: "Find and fix hidden leaks",
    icon: "Search",
  },
  {
    slug: "water-heater-repair-installation",
    title: "Water Heater Services",
    shortDesc: "Repair and installation experts",
    icon: "Flame",
  },
  {
    slug: "sewer-line-repair-replacement",
    title: "Sewer Line Services",
    shortDesc: "Professional sewer solutions",
    icon: "Construction",
  },
  {
    slug: "toilet-repair-installation",
    title: "Toilet Repair & Installation",
    shortDesc: "Complete toilet services",
    icon: "Bath",
  },
  {
    slug: "faucet-fixture-repair-installation",
    title: "Faucet & Fixture Services",
    shortDesc: "Repair and upgrade fixtures",
    icon: "Wrench",
  },
  {
    slug: "garbage-disposal",
    title: "Garbage Disposal",
    shortDesc: "Installation and repair",
    icon: "Trash2",
  },
  {
    slug: "water-pressure-problems",
    title: "Water Pressure Solutions",
    shortDesc: "Restore optimal water pressure",
    icon: "Gauge",
  },
];

// Water Purification Services
export const PURIFICATION_SERVICES = [
  {
    slug: "water-softeners",
    title: "Water Softeners",
    shortDesc: "Combat Arizona hard water",
    icon: "Droplet",
  },
  {
    slug: "whole-home-filtration",
    title: "Whole Home Filtration",
    shortDesc: "Clean water throughout your home",
    icon: "Filter",
  },
  {
    slug: "reverse-osmosis",
    title: "Reverse Osmosis Systems",
    shortDesc: "Premium drinking water",
    icon: "Beaker",
  },
  {
    slug: "arizona-hard-water",
    title: "Arizona Hard Water Solutions",
    shortDesc: "Local expertise for local problems",
    icon: "Mountain",
  },
];

// BBB Profile
export const BBB_URL = "https://www.bbb.org/us/az/tolleson/profile/plumber/tru-american-plumbing-purifications-llc-1126-1000166640";

// Social profiles for sameAs schema linking
export const SOCIAL_PROFILES = [
  "https://www.google.com/maps/place/Tru+American+Plumbing+Purifications/@33.3542164,-112.4815895,135969m/data=!3m2!1e3!4b1!4m6!3m5!1s0x2bed6e721a1d8217:0x858deda89e0d0478!8m2!3d33.3542164!4d-112.4815896!16s%2Fg%2F11yybx_jx7?entry=ttu&g_ep=EgoyMDI2MDMwOC4wIKXMDSoASAFQAw%3D%3D",
  "https://www.facebook.com/profile.php?id=61587622751294",
  "https://www.bbb.org/us/az/tolleson/profile/plumber/tru-american-plumbing-purifications-llc-1126-1000166640",
  "https://www.instagram.com/truamericanplumbing26/",
];

// Full 11-city areaServed for schema reuse
export const AREA_SERVED_SCHEMA = [
  { "@type": "City", name: "Tolleson" },
  { "@type": "City", name: "Avondale" },
  { "@type": "City", name: "Goodyear" },
  { "@type": "City", name: "Glendale" },
  { "@type": "City", name: "Peoria" },
  { "@type": "City", name: "Surprise" },
  { "@type": "City", name: "Phoenix" },
  { "@type": "City", name: "Buckeye" },
  { "@type": "City", name: "Litchfield Park" },
  { "@type": "City", name: "Sun City" },
  { "@type": "City", name: "Sun City West" },
  { "@type": "City", name: "El Mirage" },
];

// Core competencies for knowsAbout schema
export const KNOWS_ABOUT = [
  "Plumbing repair and installation",
  "Emergency plumbing services",
  "Slab leak detection",
  "Water heater repair and installation",
  "Water softener systems",
  "Reverse osmosis systems",
  "Drain cleaning",
  "Sewer line repair",
  "Arizona hard water solutions",
  "Whole home water filtration",
];

// Veteran Discount
export const VETERAN_DISCOUNT_TEXT = "Proudly Veteran-Owned — Military & First Responder Discount Available";
export const VETERAN_DISCOUNT_CTA = "Call to claim your discount";

// Trust badges
export const TRUST_BADGES = [
  "Veteran-Owned",
  "Family-Operated",
  "Licensed & Bonded",
  "Fully Insured",
  "Local West Valley Company",
];

// Canonical Plumber/Organization JSON-LD. Inject on every page via <SEO schema={[ORG_SCHEMA, ...]}>.
// Single source of truth — do NOT duplicate in index.html or inline in pages.
export const ORG_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Plumber",
  "@id": "https://truamericanplumbing.com/#organization",
  name: BUSINESS_NAME,
  alternateName: ["Tru American Plumbing & Purification", "Tru American Plumbing"],
  legalName: BUSINESS_NAME_LEGAL,
  description:
    "Veteran-owned plumbing and water purification company serving Tolleson, AZ and the West Valley. Military and first responder discounts available. Licensed, bonded & insured.",
  slogan: BUSINESS_TAGLINE,
  founder: { "@type": "Person", name: "Thomas F Trujillo" },
  telephone: "+14803222567",
  email: EMAIL,
  url: "https://truamericanplumbing.com",
  logo: "https://truamericanplumbing.com/favicon.png",
  image: "https://truamericanplumbing.com/favicon.png",
  additionalType: [
    "https://schema.org/LocalBusiness",
    "https://schema.org/HomeAndConstructionBusiness",
  ],
  geo: { "@type": "GeoCoordinates", latitude: "33.3542164", longitude: "-112.4815896" },
  areaServed: AREA_SERVED_SCHEMA,
  knowsAbout: KNOWS_ABOUT,
  sameAs: SOCIAL_PROFILES,
  hasCredential: [
    {
      "@type": "GovernmentPermit",
      name: "Arizona ROC License",
      credentialCategory: "Contractor License",
      identifier: ROC_LICENSE,
      validIn: { "@type": "AdministrativeArea", name: "Arizona" },
    },
    {
      "@type": "FinancialProduct",
      name: "Surety Bond",
      description: "Bonded for customer protection in the state of Arizona",
    },
    {
      "@type": "FinancialProduct",
      name: "General Liability Insurance",
      description: "Fully insured for residential and commercial plumbing work",
    },
    {
      "@type": "EducationalOccupationalCredential",
      name: "BBB Accredited Business",
      credentialCategory: "Business Accreditation",
      url: BBB_URL,
      recognizedBy: { "@type": "Organization", name: "Better Business Bureau" },
    },
  ],
  priceRange: "$$",
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    opens: "07:00",
    closes: "18:00",
  },
};
